import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import { Acceptor, BetSlipItem, Race, Selection } from '@mobi/betslip/types'
import { Icon } from '@mobi/component-library/Common/Icon'
import { getIconTypeFromMeetingCode } from '@core/Areas/Quickbet/helpers/IconTypeHelper'
import { MarketPillStyled, HeaderWrapperStyled } from '../Common/MultiHeader.styles'
import { SelectionDisplay } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/BetInfoHeader/Components/Common/SelectionDisplay'

export const RacingHeader: React.FC<{
  races: Race[]
  acceptors: Acceptor[]
  selection: Selection
  betLegType: BetSlipItem['multiLegBetType']
}> = ({ races, acceptors, selection, betLegType }) => {
  const { raceNumber, meetingName } = races[0]

  const iconType = getIconTypeFromMeetingCode(races[0].meetingCode)
  return (
    <HeaderWrapperStyled>
      <MarketPillStyled>
        {iconType && <Icon size='1.6rem' type={iconType} />}
        <strong>R{raceNumber}</strong> {toTitleCase(meetingName)}
      </MarketPillStyled>

      <SelectionDisplay races={races} acceptors={acceptors} selection={selection} />

      <span>{betLegType === 'W' ? 'Win' : 'Place'}</span>
    </HeaderWrapperStyled>
  )
}
